import { render, staticRenderFns } from "./SysCategoryList.vue?vue&type=template&id=46fc77c6&scoped=true"
import script from "./SysCategoryList.vue?vue&type=script&lang=js"
export * from "./SysCategoryList.vue?vue&type=script&lang=js"
import style0 from "./SysCategoryList.vue?vue&type=style&index=0&id=46fc77c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fc77c6",
  null
  
)

export default component.exports